

import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

// import Offers from '../Home/Offers/Offers';
// import Referrals from '../Home/Referrals/Referrals';
// import FinancialConsultant from '../Home/FinancialConsultant/FinancialConsultant';
// import Faqs from '../Home/Faqs/Faqs';
// import ThreeSteps from '../Home/ThreeSteps/ThreeSteps';
// import AppLink from '../Home/AppLink/AppLink';
// import StakeNow from './StakeNowSection/StakeNow';
// import Banner from './Banner/Banner';
// import Referrals from './Referrals/Referrals';
// import Schemes from './Schemes/Schemes';
import { useDispatch } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import Banner from './Banner/Banner';
import ThreeStpesTab from './ThreeSteps/ThreeStpesTab';
import ReferralsTab from './Referrals/ReferralsTab';
import HowItsWorkTab from './HowItWorks/HowItsWorkTab';
import BannerSection from './Banner/BannerSection';
import ThreeStepsSection from './ThreeSteps/ThreeStepsSection';
import ReferralsSection from './Referrals/ReferralsSection';
import HowItWorkSection from './HowItWorks/HowItWorkSection';
// import HowItsWorkTab from './HowItWorks/ThreeStpesTab';

function ReferralsContentManagement() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderTabContent = () => {
        switch (value) {
            case 0:
                return <BannerSection/>;
            case 1:
                return <ThreeStepsSection />;
            case 2:
                return <ReferralsSection />;
            case 3:
                return <HowItWorkSection />;
            default:
                return null;
        }
    }; 
    const dispatch=useDispatch()
    React.useEffect(() => {
         dispatch(setHeaderName("Content Management"));
         dispatch(setSubHeaderName("Referrals"));
       }, [dispatch]);
     

    return (
        <div>
            <Box
                sx={{
                    maxWidth: { xs: 320, sm: "100%", md: "100%" },
                    bgcolor: 'background.paper', color: "#C38F51", p: 1
                }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable auto tabs example"
                    sx={{ '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" } }}
                    TabIndicatorProps={{
                        style: {
                            mt: 0,

                            backgroundColor: '#C38F51',
                            height: '3px', // Adjust the thickness of the bottom border
                        },
                    }}
                >
                    {['Banner', '3 Steps','Referrals', "How it Works"].map(
                        (label, index) => (
                            <Tab
                                key={label}
                                label={label}
                                sx={{
                                    '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" },
                                    fontSize: "16px",
                                    color: value === index ? '#C38F51' : 'black',
                                    textTransform: 'none',
                                    fontWeight: value === index ? 'bold' : 'normal',
                                    borderBottom:
                                        value === index ? '3px solid #C38F51' : 'none',
                                    // minWidth: 100, // Ensures tabs have a minimum width  transition: 'color 0.3s ease', // Smooth transition for color change
                                    '&.Mui-selected': {
                                        color: '#C38F51', // Ensures proper application for the selected tab
                                    },
                                    '&:hover': {
                                        color: '#C38F51', // Hover effect for unselected tabs
                                    },
                                }}
                            />
                        )
                    )}
                </Tabs>
            </Box>
            <Box sx={{ py: 2 }}>{renderTabContent()}</Box>
        </div >
    );
}

export default ReferralsContentManagement;
